import axios from "axios";
import { HistoricalNavResult } from "../types";
import getServiceEndpoint from "./ServiceEndpoint";
import { buildClientHeader } from "./buildHeader";

/**
 * Get historical NAV data for a fund
 * @param fundId - The fund ID to get historical NAV data for
 * @returns Promise resolving to an array of historical NAV results
 */
export const getHistoricalNav = async (
  fundId: number
): Promise<HistoricalNavResult[]> => {
  try {
    const response = await axios.get(
      `${getServiceEndpoint()}/analytics/historical-nav?fundId=${fundId}`,
      buildClientHeader()
    );
    
    if (response.status !== 200 || response.data === undefined) {
      console.log("Failed to retrieve historical NAV data", response.statusText);
      return [];
    }
    
    return response.data ?? [];
  } catch (error) {
    console.error("Error getting historical NAV data:", error);
    return [];
  }
}; 